// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.share-embed-dialog {
  width: 100%;
  max-width: 520px;
  box-sizing: border-box;
  font-family: "Raleway", Arial, Helvetica, sans-serif;
}
.share-embed-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}
.share-embed-dialog .dialog-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}
.share-embed-dialog .dialog-header .close-btn {
  color: #64748b;
}
.share-embed-dialog .dialog-content {
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.share-embed-dialog .option-group {
  display: flex;
  flex-direction: column;
}
.share-embed-dialog .option-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #303030;
  margin-bottom: 8px;
}
.share-embed-dialog .full-width {
  width: 100%;
}
.share-embed-dialog .code-field textarea {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  line-height: 1.45;
}
.share-embed-dialog .size-preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.share-embed-dialog .size-preset-btn {
  border: 1px solid #d0d0d0;
  background: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
}
.share-embed-dialog .size-preset-btn.active {
  border-color: #5ea1d8;
  background: #eef6fc;
  color: #1a5f96;
}
.share-embed-dialog .custom-size-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 8px;
  align-items: center;
}
.share-embed-dialog .size-separator {
  color: #888;
  font-size: 14px;
}
.share-embed-dialog .inline-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 4px;
}
.share-embed-dialog .copy-field-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: start;
}
.share-embed-dialog .copy-field-btn {
  margin-top: 4px;
  white-space: nowrap;
}
.share-embed-dialog .btn-primary,
.share-embed-dialog .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-family: "Raleway";
  margin: 0 !important;
}
.share-embed-dialog .btn-primary {
  background: #5ea1d8;
  color: white;
}
.share-embed-dialog .btn-primary:hover {
  background: #4a8fc4;
}
.share-embed-dialog .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.share-embed-dialog .btn-secondary:hover {
  background: #e5e7eb;
}
@media (max-width: 600px) {
  .share-embed-dialog .inline-actions {
    flex-direction: column;
  }
  .share-embed-dialog .inline-actions .btn-primary,
  .share-embed-dialog .inline-actions .btn-secondary {
    width: 100%;
  }
  .share-embed-dialog .copy-field-row {
    grid-template-columns: 1fr;
  }
  .share-embed-dialog .copy-field-btn {
    width: 100%;
    margin-top: 0;
  }
}

:host-context(body.theme-dark) .share-embed-dialog,
:host-context(body.theme-dark) .share-embed-dialog .dialog-header,
:host-context(body.theme-dark) .share-embed-dialog .dialog-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .share-embed-dialog h2,
:host-context(body.theme-dark) .share-embed-dialog .option-label,
:host-context(body.theme-dark) .share-embed-dialog .close-btn {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .share-embed-dialog .size-preset-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .share-embed-dialog .size-preset-btn.active {
  background: rgba(94, 161, 216, 0.2) !important;
  border-color: #5ea1d8 !important;
  color: #dbeafe !important;
}
:host-context(body.theme-dark) .share-embed-dialog .btn-secondary {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}

/* Flowchest YouTube Hybrid Share Dialog */
.flowchest-share-dialog.flowchest-branded {
  font-family: "Segoe UI", "Roboto", Helvetica, Arial, sans-serif;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  max-width: 500px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* Header Section */
.flowchest-share-dialog.flowchest-branded .flowchest-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 8px 24px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-dialog-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.01em;
}

.flowchest-share-dialog.flowchest-branded .flowchest-close-btn {
  color: #64748b;
  transition: color 0.2s ease;
}

.flowchest-share-dialog.flowchest-branded .flowchest-close-btn:hover {
  color: #0f172a;
}

/* Content Panel */
.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {
  padding: 0 24px 24px 24px;
  /* Show an auto scroller when the content exceeds the modal height */
  max-height: calc(85vh - 64px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar {
  width: 8px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-track {
  background: transparent;
}

.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 999px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

/* Circular Icon Buttons styling with a hint of flowchest cyan/blue theme */
.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  min-width: 64px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn .flowchest-icon-circle {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), background-color 0.2s ease;
  overflow: hidden;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn:hover .flowchest-icon-circle {
  background-color: #e2e8f0;
  transform: scale(1.06);
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn img {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #334155;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn span {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-top: 8px;
  text-align: center;
  white-space: nowrap;
}

/* Selected/active share option highlights the icon in Flowchest blue */
.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle {
  background-color: #0284c7;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle mat-icon {
  color: #ffffff;
}

.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active span {
  color: #0284c7;
}

/* 2. Branded Premium Copy Action Bar */
.flowchest-share-dialog.flowchest-branded .flowchest-share-url-container {
  margin-top: 20px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box {
  display: flex;
  align-items: center;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 6px 6px 6px 16px;
  height: 48px;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box:focus-within {
  border-color: #38bdf8;
}

.flowchest-share-dialog.flowchest-branded .flowchest-link-input {
  flex-grow: 1;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #334155;
  outline: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 600;
  height: 36px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(2, 132, 199, 0.2);
}

.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn:hover {
  opacity: 0.95;
}

.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn:active {
  transform: scale(0.98);
}

/* 3. Embed Layout Panel Configurations */
.flowchest-share-dialog.flowchest-branded .flowchest-section-divider {
  border: 0;
  border-top: 1px solid #f1f5f9;
  margin: 20px 0;
}

.flowchest-share-dialog.flowchest-branded .flowchest-embed-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-embed-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flowchest-share-dialog.flowchest-branded .flowchest-setting-row label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.flowchest-share-dialog.flowchest-branded .flowchest-compact-select {
  width: 160px;
  font-size: 13px;
}

/* Preset Badge Pills adjustments */
.flowchest-share-dialog.flowchest-branded .flowchest-size-config {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-presets {
  display: flex;
  gap: 6px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge {
  background: #f1f5f9;
  border: 1px solid transparent;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge:hover {
  background: #e2e8f0;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge.flowchest-active {
  background: #0f172a;
  color: #ffffff;
}

.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #64748b;
}

.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input {
  width: 54px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 12px;
  text-align: center;
  color: #334155;
  outline: none;
}

.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input:focus {
  border-color: #38bdf8;
}

/* HTML Snippet block customization */
.flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {
  width: 100%;
  box-sizing: border-box;
  background: #fafafa;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: #334155;
  resize: none;
  outline: none;
}

.flowchest-share-dialog.flowchest-branded .flowchest-embed-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn {
  background: transparent;
  border: none;
  color: #0284c7;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn:hover {
  text-decoration: underline;
}

/* Embed Preview Controls */
.flowchest-share-dialog.flowchest-branded .flowchest-preview-trigger-row {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f1f5f9;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn:hover {
  background: #e2e8f0;
}

.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

/* Live Preview Container styling */
.flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f1f5f9;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 480px;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container app-embed-preview {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

/* Container sizing rule */
.flowchest-share-dialog.flowchest-branded .flowchest-social-share-container {
  position: relative;
  margin: 20px 0;
  width: 100%;
  overflow: hidden;
}

/* Horizontal Scroll Configuration */
.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper {
  display: flex;
  gap: 10px;
  /* Enable horizontal scrolling mechanics */
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 4px 4px 12px 4px; /* Added bottom padding to clear inner bounds */
  /* Smooth touch inertial scrolling for iOS/Mobile devices */
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  /* Hide native standard scrollbars */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

/* Hide native scrollbars for Chrome, Safari, and Opera browsers */
.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* Ensure child buttons retain shape without squishing inside the scroller */
.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  /* Explicit layout containment values prevent flex auto-shrinking */
  flex: 0 0 64px;
  width: 64px;
}

/* Mobile: fit share/embed preview to screen — no horizontal scroll */
@media (max-width: 768px) {
  .flowchest-share-dialog.flowchest-branded {
    max-width: 100%;
    border-radius: 12px;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {
    padding: 0 16px 20px 16px;
    overflow-x: hidden;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-setting-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-compact-select {
    width: 100%;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-size-config {
    flex-wrap: wrap;
    width: 100%;
    gap: 8px;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-presets {
    flex-wrap: wrap;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-preview-trigger-row {
    flex-wrap: wrap;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-embed-actions {
    flex-wrap: wrap;
    gap: 10px;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {
    max-height: none;
    width: 100%;
    overflow-x: hidden;
  }
  .flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {
    word-break: break-all;
    white-space: pre-wrap;
  }
}
/* Dark mode — share dialog on view flow & view bundle */
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-dialog-header h2,
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-close-btn,
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-setting-row label,
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs,
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn span {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-close-btn:hover {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {
  scrollbar-color: #475569 transparent;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb {
  background-color: #475569;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn .flowchest-icon-circle {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn:hover .flowchest-icon-circle {
  background-color: #374151 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle {
  background-color: #0284c7 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active span {
  color: #38bdf8 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box {
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box:focus-within {
  border-color: #38bdf8 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-link-input {
  color: #f8fafc !important;
  background: transparent !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-section-divider {
  border-top-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge:hover {
  background: #374151 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge.flowchest-active {
  background: #0284c7 !important;
  color: #ffffff !important;
  border-color: #0284c7 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input:focus {
  border-color: #38bdf8 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn {
  color: #38bdf8 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn:hover {
  background: #374151 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn mat-icon,
:host-context(body.theme-dark) .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn span {
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/embeded/embeded.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,oDAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAEJ;AAAI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEN;AACI;EACE,cAAA;AACN;AAGE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAOE;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAQE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AANJ;AASE;EACE,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAPJ;AASI;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAPN;AAWE;EACE,aAAA;EACA,mCAAA;EACA,QAAA;EACA,mBAAA;AATJ;AAYE;EACE,WAAA;EACA,eAAA;AAVJ;AAaE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAXJ;AAcE;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;AAZJ;AAeE;EACE,eAAA;EACA,mBAAA;AAbJ;AAgBE;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,YAAA;AAfJ;AAiBI;EACE,mBAAA;AAfN;AAmBE;EACE,mBAAA;EACA,cAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;AAqBE;EACE;IACE,sBAAA;EAnBJ;EAsBE;;IAEE,WAAA;EApBJ;EAuBE;IACE,0BAAA;EArBJ;EAwBE;IACE,WAAA;IACA,aAAA;EAtBJ;AACF;;AA2BE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAxBJ;AA2BE;;;EAGE,yBAAA;AAzBJ;AA4BE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA1BJ;AA6BE;EACE,8CAAA;EACA,gCAAA;EACA,yBAAA;AA3BJ;AA8BE;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AA5BJ;;AA+BA,0CAAA;AACA;EACE,+DAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,WAAA;EACA,qCAAA;AA5BF;;AA+BA,mBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,2BAAA;AA5BF;;AA+BA;EACE,cAAA;AA5BF;;AA+BA,kBAAA;AACA;EACE,yBAAA;EAEA,oEAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,oCAAA;AA7BF;;AAgCA;EACE,UAAA;AA7BF;;AAgCA;EACE,uBAAA;AA7BF;;AAgCA;EACE,yBAAA;EACA,oBAAA;AA7BF;;AAgCA;EACE,yBAAA;AA7BF;;AAiCA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA9BF;;AAiCA;EACE,aAAA;AA9BF;;AAiCA,2EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wFAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AA9BF;;AAiCA,uEAAA;AACA;EACE,yBAAA;AA9BF;;AAgCA;EACE,cAAA;AA7BF;;AA+BA;EACE,cAAA;AA5BF;;AA+BA,uCAAA;AACA;EACE,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,kCAAA;AA5BF;;AA+BA;EACE,qBAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,6DAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EACE,sBAAA;AA5BF;;AA+BA,yCAAA;AACA;EACE,SAAA;EACA,6BAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,eAAA;AA5BF;;AA+BA,mCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,QAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AA5BF;;AA+BA;EACE,mBAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AA5BF;;AA+BA;EACE,qBAAA;AA5BF;;AA+BA,qCAAA;AACA;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,6EAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,0BAAA;AA5BF;;AA8BA,2BAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sCAAA;AA3BF;;AA8BA;EACE,mBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3BF;;AA8BA,mCAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA3BF;;AA6BA,0BAAA;AACA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AA1BF;;AA6BA,oCAAA;AACA;EACE,aAAA;EACA,SAAA;EAEA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA,EAAA,+CAAA;EAEA,2DAAA;EACA,iCAAA;EACA,uBAAA;EAEA,oCAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,YAAA;AA7BF;;AAgCA,kEAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,SAAA;AA7BF;;AAgCA,4EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EAEA,mEAAA;EACA,cAAA;EACA,WAAA;AA9BF;;AAiCA,qEAAA;AACA;EACE;IACE,eAAA;IACA,mBAAA;EA9BF;EAiCA;IACE,yBAAA;IACA,kBAAA;EA/BF;EAkCA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAhCF;EAmCA;IACE,WAAA;EAjCF;EAoCA;IACE,eAAA;IACA,WAAA;IACA,QAAA;EAlCF;EAqCA;IACE,eAAA;EAnCF;EAsCA;IACE,eAAA;EApCF;EAuCA;IACE,eAAA;IACA,SAAA;EArCF;EAwCA;IACE,gBAAA;IACA,WAAA;IACA,kBAAA;EAtCF;EAyCA;IACE,qBAAA;IACA,qBAAA;EAvCF;AACF;AA0CA,wDAAA;AAEE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;EACA,sDAAA;AAzCJ;AA4CE;;;;;EAKE,yBAAA;AA1CJ;AA6CE;EACE,yBAAA;AA3CJ;AA8CE;EACE,oCAAA;AA5CJ;AA+CE;EACE,yBAAA;AA7CJ;AAgDE;EACE,yBAAA;AA9CJ;AAiDE;EACE,oCAAA;AA/CJ;AAkDE;EACE,oCAAA;AAhDJ;AAmDE;EACE,yBAAA;AAjDJ;AAoDE;EACE,oCAAA;AAlDJ;AAqDE;EACE,yBAAA;AAnDJ;AAsDE;EACE,yBAAA;AApDJ;AAuDE;EACE,oCAAA;EACA,kDAAA;AArDJ;AAwDE;EACE,gCAAA;AAtDJ;AAyDE;EACE,yBAAA;EACA,kCAAA;AAvDJ;AA0DE;EACE,sDAAA;AAxDJ;AA2DE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAzDJ;AA4DE;EACE,8BAAA;AA1DJ;AA6DE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA3DJ;AA8DE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA5DJ;AA+DE;EACE,gCAAA;AA7DJ;AAgEE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA9DJ;AAiEE;EACE,yBAAA;AA/DJ;AAkEE;EACE,8BAAA;EACA,yBAAA;AAhEJ;AAmEE;EACE,8BAAA;AAjEJ;AAoEE;EACE,yBAAA;AAlEJ;AAqEE;EACE,8BAAA;EACA,kDAAA;AAnEJ;AAsEE;EACE,yBAAA;AApEJ;AAuEE;;EAEE,yBAAA;AArEJ","sourcesContent":[".share-embed-dialog {\n  width: 100%;\n  max-width: 520px;\n  box-sizing: border-box;\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e2e8f0;\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    .close-btn {\n      color: #64748b;\n    }\n  }\n\n  .dialog-content {\n    padding: 16px 20px 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  .option-group {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .option-label {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: #303030;\n    margin-bottom: 8px;\n  }\n\n  .full-width {\n    width: 100%;\n  }\n\n  .code-field textarea {\n    font-family: Consolas, Monaco, monospace;\n    font-size: 12px;\n    line-height: 1.45;\n  }\n\n  .size-preset-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .size-preset-btn {\n    border: 1px solid #d0d0d0;\n    background: #fff;\n    border-radius: 999px;\n    padding: 6px 12px;\n    font-size: 12px;\n    cursor: pointer;\n\n    &.active {\n      border-color: #5ea1d8;\n      background: #eef6fc;\n      color: #1a5f96;\n    }\n  }\n\n  .custom-size-row {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    gap: 8px;\n    align-items: center;\n  }\n\n  .size-separator {\n    color: #888;\n    font-size: 14px;\n  }\n\n  .inline-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 4px;\n  }\n\n  .copy-field-row {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 12px;\n    align-items: start;\n  }\n\n  .copy-field-btn {\n    margin-top: 4px;\n    white-space: nowrap;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n    font-family: \"Raleway\";\n    margin: 0 !important;\n  }\n\n  .btn-primary {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover {\n      background: #4a8fc4;\n    }\n  }\n\n  .btn-secondary {\n    background: #f3f4f6;\n    color: #374151;\n\n    &:hover {\n      background: #e5e7eb;\n    }\n  }\n\n  @media (max-width: 600px) {\n    .inline-actions {\n      flex-direction: column;\n    }\n\n    .inline-actions .btn-primary,\n    .inline-actions .btn-secondary {\n      width: 100%;\n    }\n\n    .copy-field-row {\n      grid-template-columns: 1fr;\n    }\n\n    .copy-field-btn {\n      width: 100%;\n      margin-top: 0;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .share-embed-dialog,\n  .share-embed-dialog .dialog-header,\n  .share-embed-dialog .dialog-content {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .share-embed-dialog h2,\n  .share-embed-dialog .option-label,\n  .share-embed-dialog .close-btn {\n    color: #e2e8f0 !important;\n  }\n\n  .share-embed-dialog .size-preset-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .share-embed-dialog .size-preset-btn.active {\n    background: rgba(94, 161, 216, 0.2) !important;\n    border-color: #5ea1d8 !important;\n    color: #dbeafe !important;\n  }\n\n  .share-embed-dialog .btn-secondary {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border: 1px solid rgba(148, 163, 184, 0.35) !important;\n  }\n}\n/* Flowchest YouTube Hybrid Share Dialog */\n.flowchest-share-dialog.flowchest-branded {\n  font-family: \"Segoe UI\", \"Roboto\", Helvetica, Arial, sans-serif;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  max-width: 500px;\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Header Section */\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px 8px 24px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-close-btn {\n  color: #64748b;\n  transition: color 0.2s ease;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-close-btn:hover {\n  color: #0f172a;\n}\n\n/* Content Panel */\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {\n  padding: 0 24px 24px 24px;\n\n  /* Show an auto scroller when the content exceeds the modal height */\n  max-height: calc(85vh - 64px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 999px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n}\n \n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  scrollbar-width: none;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Circular Icon Buttons styling with a hint of flowchest cyan/blue theme */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  min-width: 64px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn .flowchest-icon-circle {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background-color: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), background-color 0.2s ease;\n  overflow: hidden;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn:hover .flowchest-icon-circle {\n  background-color: #e2e8f0;\n  transform: scale(1.06);\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn img {\n  width: 24px;\n  height: 24px;\n  display: block;\n  object-fit: contain;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn mat-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  color: #334155;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn span {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  margin-top: 8px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Selected/active share option highlights the icon in Flowchest blue */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle {\n  background-color: #0284c7;\n}\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle mat-icon {\n  color: #ffffff;\n}\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active span {\n  color: #0284c7;\n}\n\n/* 2. Branded Premium Copy Action Bar */\n.flowchest-share-dialog.flowchest-branded .flowchest-share-url-container {\n  margin-top: 20px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box {\n  display: flex;\n  align-items: center;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 6px 6px 6px 16px;\n  height: 48px;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box:focus-within {\n  border-color: #38bdf8;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-link-input {\n  flex-grow: 1;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: #334155;\n  outline: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn {\n  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 0 20px;\n  font-size: 14px;\n  font-weight: 600;\n  height: 36px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s ease;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  box-shadow: 0 2px 4px rgba(2, 132, 199, 0.2);\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn:hover {\n  opacity: 0.95;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-copy-btn:active {\n  transform: scale(0.98);\n}\n\n/* 3. Embed Layout Panel Configurations */\n.flowchest-share-dialog.flowchest-branded .flowchest-section-divider {\n  border: 0;\n  border-top: 1px solid #f1f5f9;\n  margin: 20px 0;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-embed-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-embed-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-setting-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-setting-row label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-compact-select {\n  width: 160px;\n  font-size: 13px;\n}\n\n/* Preset Badge Pills adjustments */\n.flowchest-share-dialog.flowchest-branded .flowchest-size-config {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-presets {\n  display: flex;\n  gap: 6px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge {\n  background: #f1f5f9;\n  border: 1px solid transparent;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge:hover {\n  background: #e2e8f0;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preset-badge.flowchest-active {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input {\n  width: 54px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  padding: 4px 6px;\n  font-size: 12px;\n  text-align: center;\n  color: #334155;\n  outline: none;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input:focus {\n  border-color: #38bdf8;\n}\n\n/* HTML Snippet block customization */\n.flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {\n  width: 100%;\n  box-sizing: border-box;\n  background: #fafafa;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  color: #334155;\n  resize: none;\n  outline: none;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-embed-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn {\n  background: transparent;\n  border: none;\n  color: #0284c7;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn:hover {\n  text-decoration: underline;\n}\n/* Embed Preview Controls */\n.flowchest-share-dialog.flowchest-branded .flowchest-preview-trigger-row {\n  display: flex;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #f1f5f9;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn:hover {\n  background: #e2e8f0;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-preview-btn mat-icon {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n/* Live Preview Container styling */\n.flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f1f5f9;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 480px;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container app-embed-preview {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n/* Container sizing rule */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-share-container {\n  position: relative;\n  margin: 20px 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* Horizontal Scroll Configuration */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper {\n  display: flex;\n  gap: 10px;\n  \n  /* Enable horizontal scrolling mechanics */\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  padding: 4px 4px 12px 4px; /* Added bottom padding to clear inner bounds */\n  \n  /* Smooth touch inertial scrolling for iOS/Mobile devices */\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n  \n  /* Hide native standard scrollbars */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge */\n}\n\n/* Hide native scrollbars for Chrome, Safari, and Opera browsers */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icons-scroll-wrapper::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n/* Ensure child buttons retain shape without squishing inside the scroller */\n.flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  \n  /* Explicit layout containment values prevent flex auto-shrinking */\n  flex: 0 0 64px;\n  width: 64px;\n}\n\n/* Mobile: fit share/embed preview to screen — no horizontal scroll */\n@media (max-width: 768px) {\n  .flowchest-share-dialog.flowchest-branded {\n    max-width: 100%;\n    border-radius: 12px;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {\n    padding: 0 16px 20px 16px;\n    overflow-x: hidden;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-setting-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-compact-select {\n    width: 100%;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-size-config {\n    flex-wrap: wrap;\n    width: 100%;\n    gap: 8px;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-presets {\n    flex-wrap: wrap;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preview-trigger-row {\n    flex-wrap: wrap;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-embed-actions {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {\n    max-height: none;\n    width: 100%;\n    overflow-x: hidden;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {\n    word-break: break-all;\n    white-space: pre-wrap;\n  }\n}\n\n/* Dark mode — share dialog on view flow & view bundle */\n:host-context(body.theme-dark) {\n  .flowchest-share-dialog.flowchest-branded {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-header h2,\n  .flowchest-share-dialog.flowchest-branded .flowchest-close-btn,\n  .flowchest-share-dialog.flowchest-branded .flowchest-setting-row label,\n  .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs,\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn span {\n    color: #e2e8f0 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-close-btn:hover {\n    color: #f8fafc !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content {\n    scrollbar-color: #475569 transparent;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb {\n    background-color: #475569;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-dialog-content::-webkit-scrollbar-thumb:hover {\n    background-color: #64748b;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn .flowchest-icon-circle {\n    background-color: #1f2937 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn:hover .flowchest-icon-circle {\n    background-color: #374151 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle {\n    background-color: #0284c7 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active .flowchest-icon-circle mat-icon {\n    color: #ffffff !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-social-icon-btn.flowchest-active span {\n    color: #38bdf8 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box {\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-copy-url-box:focus-within {\n    border-color: #38bdf8 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-link-input {\n    color: #f8fafc !important;\n    background: transparent !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-section-divider {\n    border-top-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge:hover {\n    background: #374151 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preset-badge.flowchest-active {\n    background: #0284c7 !important;\n    color: #ffffff !important;\n    border-color: #0284c7 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-custom-inputs input:focus {\n    border-color: #38bdf8 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-embed-code-box textarea {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-text-link-btn {\n    color: #38bdf8 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn:hover {\n    background: #374151 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-preview-btn mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-live-preview-container {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn {\n    color: #ffffff !important;\n  }\n\n  .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn mat-icon,\n  .flowchest-share-dialog.flowchest-branded .flowchest-copy-btn span {\n    color: #ffffff !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
